// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","411":"component---src-pages-contato-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"0c56052fc4e554db039e","411":"8fe66da0c62cdc2f4903","691":"6e0d9122ef44535adf20"}[chunkId] + ".js";
};